export default {
  schema: {
    type: 'object',
    required: ['requiredCheckboxQuestion'],
    properties: {
      booleanHelpQuestion: {
        title: 'Boolean Help Question',
        type: 'boolean'
      },
      booleanQuestion: {
        title: 'Boolean Question',
        type: 'boolean'
      },
      checkboxQuestion: {
        title: 'Checkbox Question',
        type: 'array',
        uniqueItems: true,
        items: {
          type: 'string',
          enum: ['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5', 'Option 6'],
          enumNames: ['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5', 'Option 6']
        }
      },
      requiredCheckboxQuestion: {
        title: 'Required Checkbox Question',
        type: 'array',
        uniqueItems: true,
        items: {
          type: 'string',
          enum: ['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5', 'Option 6'],
          enumNames: ['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5', 'Option 6']
        }
      },
      npresp: {
        title: 'Normal Professional Responsibility',
        type: 'array',
        uniqueItems: true,
        items: {
          type: 'string',
          enum: ['Administration', 'Doctoral Level Teaching/Mentoring', 'Executive Education', 'Graduate Teaching', "Master's Level Teaching", 'Non-Credit Teaching', 'Research', 'Undergraduate Teaching', 'Other Service and Outreach Responsibilities'],
          enumNames: ['Administration', 'Doctoral Level Teaching/Mentoring', 'Executive Education', 'Graduate Teaching', "Master's Level Teaching", 'Non-Credit Teaching', 'Research', 'Undergraduate Teaching', 'Other Service and Outreach Responsibilities']
        }
      }
    }
  },
  uiSchema: {
    booleanHelpQuestion: {
      'ui:widget': 'checkbox',
      'ui:help': {
        escape: true,
        text: 'Here is some help text'
      }
    },
    booleanQuestion: {
      'ui:widget': 'checkbox'
    },
    checkboxQuestion: {
      'ui:widget': 'checkboxes'
    },
    requiredCheckboxQuestion: {
      'ui:widget': 'checkboxes'
    },
    npresp: {
      'ui:widget': 'checkboxes'
    },
    'dm:layout': [{
      type: 'field',
      id: 'booleanHelpQuestion'
    }, {
      type: 'field',
      id: 'booleanQuestion'
    }, {
      type: 'field',
      id: 'checkboxQuestion'
    }, {
      type: 'field',
      id: 'requiredCheckboxQuestion'
    }, {
      type: 'field',
      id: 'npresp'
    }]
  },
  formData: {}
};